export default "__VITE_ASSET__BA5ukiqp__"